import React from "react";
import { useState, useEffect } from 'react';
import Webcam from "react-webcam";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Grid from '@mui/material/Grid';
import CameraIcon from '@mui/icons-material/Camera';
import ClearIcon from '@mui/icons-material/Clear';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Stack from '@mui/material/Stack';
import CameraswitchIcon from '@mui/icons-material/Cameraswitch';

import Fab from '@mui/material/Fab';
import Avatar from '@mui/material/Avatar';
import { LocalizationContext } from '../../App';


const LoupeCameraComponent = (props) => {

    const fabSize = 50;

    const currentItem = props.currentItem;
    const [ currentDeviceIdx, setCurrentDeviceIdx ] = React.useState(0);
    
    const webcamRef = React.useRef(null);
    const [imgSrc, setImgSrc] = React.useState(currentItem.selectedValue);
    
    const [ isImaging, setIsImaging ] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    
    const [deviceId, setDeviceId] = React.useState({});
    const [devices, setDevices] = React.useState([]);

    const handleDevices = React.useCallback(
        mediaDevices =>
        setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
        [setDevices]
    );

    const increaseIdx = () => {
        var cVal = currentDeviceIdx;
        if( (cVal + 1) >= devices.length ) {
            cVal = 0;
        } else {
            cVal += 1;
        }

        setCurrentDeviceIdx(cVal);
    }

    React.useEffect(
        () => {
        navigator.mediaDevices.enumerateDevices().then(handleDevices);
        },
        [handleDevices]
    );


    const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setIsImaging(false);
        setImgSrc(imageSrc);
        currentItem.selectedValue = imageSrc;
    }, [webcamRef, setImgSrc]);

    const clearImage = () => {
        setImgSrc(null);
        currentItem.selectedValue = null;
    }

    // const videoConstraints = {
    //     //facingMode: { exact: "environment" } //environment //user
    // };

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
          width,
          height
        };
      }


    useEffect(() => {
        function handleResize() {
          setWindowDimensions(getWindowDimensions());
        }
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 
        <div>

        { devices.length == 0 ? (
            <></>
        ) : (
       <>
        <LoupeItemHeaderComponent currentItem={currentItem} />                        
                
        {!hasError && !isImaging && !imgSrc && (

            <Grid container>
                <Grid item xs={12} md={12}>
                    <Button onClick={() => setIsImaging(true)}>
                        <CameraAltIcon />
                    </Button>
                </Grid>
            </Grid>
        )}

        {!hasError && !isImaging && imgSrc && (
                    
            <React.Fragment>
                <Grid container>

                    <Grid item xs={12} md={12}>
                        <img src={imgSrc} width="75%" sx={{ maxHeight : '640px' }}/> 
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <p />

                        <Button onClick={() => setIsImaging(true)}>
                            <CameraAltIcon />
                        </Button>

                        <Button onClick={clearImage}>
                            <DeleteForeverIcon />
                        </Button>

                    </Grid>

                </Grid>
            </React.Fragment>
        )}

        {!hasError && isImaging && (

            <React.Fragment>

                <Dialog
                    fullScreen
                    fullWidth
                    open={isImaging}>


                    {/* <div 
                        style={{ 
                            overflow : 'hidden',
                            width : '100vw', 
                            height : '100vh', 
                            backgroundColor : 'black', 
                            textAlign : 'center', 
                            position : 'absolute', 
                            top: '0', 
                            bottom : '0', 
                            left : '0', 
                            right : '0', 
                            zIndex : '10' }}> */}
                    
                    <Webcam                 
                        width={'100%'}
                        onUserMediaError={() => setHasError(true)}
                        videoConstraints={{      
                            facingMode: { exact: "environment" },                       
                            deviceId : devices[currentDeviceIdx].deviceId,
                        }}
                        forceScreenshotSourceSize={true}
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"/>   

                    {/* </div> */}

                    <div style={{ backgroundColor : 'transparent', borderRadius : '15px', textAlign : 'center', position : 'absolute', padding : '10px', margin : '10px', bottom : '0', left : '0', right : '0', zIndex : '50' }}>
                        <Grid container justifyContent="center">
                            <Grid item xs>
                                <Fab sx={{ width: fabSize, height: fabSize }} onClick={() => setIsImaging(false)}>
                                    <ClearIcon />
                                </Fab> 
                            </Grid>

                            <Grid item xs>
                                <Fab color="primary" sx={{ width: fabSize, height: fabSize }} onClick={capture}>
                                    <CameraIcon />
                                </Fab>
                            </Grid>

                            { devices.length > 1 && (
                                <Grid item xs>
                                    <Fab sx={{ width: fabSize, height: fabSize }} onClick={() => increaseIdx()}>
                                        <CameraswitchIcon />
                                    </Fab> 
                                </Grid>
                            )}
                           
                        </Grid>
                    </div>

                </Dialog>
            </React.Fragment>
            
            
            )}

         {hasError && (
             <React.Fragment>
                 <Grid container>

                <Grid item xs={12} md={12}>
                    <Alert severity="error">
                        {strings.getString("errors.camera.unsupported.message")}
                    </Alert>
            </Grid>
            </Grid>
            </React.Fragment>
         )}
</>
         )}

        </div>
        }
        </LocalizationContext.Consumer>
       
    );


};
export default LoupeCameraComponent;